import { RequestParams } from '../../hooks/useAPI'
import { ExpFilterState } from '../state/managementFilters'
import { mapStatusToSearchParameters } from './mapStatusToSearchParameter'

export const convertToQueryParams = (filterState: ExpFilterState): RequestParams => {
    const statusParams = mapStatusToSearchParameters(filterState.status)

    const params = {
        page: filterState.page,
        size: filterState.pageSize,
        name: filterState.name,
        domain: filterState.domain,
        startDateAfter: filterState.startDateTime ? filterState.startDateTime?.toISOString() : '',
        endDateBefore: filterState.endDateTime ? filterState.endDateTime?.toISOString() : '',
        ...statusParams,
    }

    return Object.fromEntries(
        Object.entries(params).filter(([, value]) => {
            return (
                (typeof value === 'string' && value.length > 0) ||
                typeof value === 'number' ||
                typeof value === 'boolean'
            )
        })
    )
}
